import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateExamWithTestsDto,
  CreateUpdateExternalReferralDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import { Selector } from '../Selects/Selector';
import { SchoolCandidateSelector } from '../Selects/SchoolCandidateSelector';
import { KindOfScienceSelector } from '../Selects/KindOfScienceSelector';

interface StudentFormProps {
  externalReferral: CreateUpdateExternalReferralDto;
  textOrEmpty: (text: string | null | undefined) => string;
  propertyChangeExam: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
  putSchoolName: () => void;
  putSchoolAddress: () => void;
  changeExternalReferral: (jobPositionId: string, fieldName: string) => void;
  spdCore: {
    jobPositions: {
      getAllForSelector: (
        text: string,
      ) => Promise<{ label: string; value: string }[]>;
    };
  };
}

const StudentForm: React.FC<StudentFormProps> = ({
  externalReferral,
  textOrEmpty,
  propertyChangeExam,
  putSchoolName,
  putSchoolAddress,
  changeExternalReferral,
  spdCore,
}) => {
  return (
    <>
      <Card.Subtitle className="mb-4 mt-4">Placówka dydaktyczna</Card.Subtitle>
      <FormRow controlId="school_candidate" label="Uczeń/Kandydat">
        <SchoolCandidateSelector
          value={externalReferral?.examWithTests?.schoolCandidate}
          onChange={value => propertyChangeExam({ schoolCandidate: value })}
        />
      </FormRow>
      <FormRow controlId="kindOfScience" label="Rodzaj nauki lub kształcenia">
        <KindOfScienceSelector
          value={externalReferral?.examWithTests?.kindOfScience}
          onChange={value => propertyChangeExam({ kindOfScience: value })}
        />
      </FormRow>
      {externalReferral?.examWithTests?.schoolCandidate === false && (
        <FormRow controlId="schoolPeriod" label="Okres nauki">
          <Form.Control
            as="textarea"
            rows={2}
            value={textOrEmpty(externalReferral?.examWithTests?.schoolPeriod)}
            onChange={e => propertyChangeExam({ schoolPeriod: e.target.value })}
          />
        </FormRow>
      )}
      <FormRow controlId="schoolName" label="Nazwa placówki dydaktycznej">
        <div className="d-flex flex-column">
          <Button
            variant="outline-secondary"
            onClick={putSchoolName}
            className="mt-2 align-self-start"
          >
            Wstaw nazwę swojej firmy
          </Button>
          <Form.Control
            as="textarea"
            rows={3}
            value={textOrEmpty(externalReferral?.examWithTests?.schoolName)}
            onChange={e => propertyChangeExam({ schoolName: e.target.value })}
          />
        </div>
      </FormRow>
      <FormRow controlId="schoolAddress" label="Adres placówki dydaktycznej">
        <div className="d-flex flex-column">
          <Button
            variant="outline-secondary"
            onClick={putSchoolAddress}
            className="mt-2 align-self-start"
          >
            Wstaw adres swojej firmy
          </Button>
          <Form.Control
            as="textarea"
            rows={3}
            value={textOrEmpty(externalReferral?.examWithTests?.schoolAddress)}
            onChange={e =>
              propertyChangeExam({ schoolAddress: e.target.value })
            }
          />
        </div>
      </FormRow>
      <FormRow
        controlId="jobPosition"
        label="Predefiniowane stanowisko i czynniki szkodliwe"
      >
        <Selector
          onChange={chosen =>
            changeExternalReferral(chosen.value, 'fieldOfStudy')
          }
          provider={spdCore.jobPositions.getAllForSelector}
        />
      </FormRow>
      <FormRow
        controlId="fieldOfStudy"
        label="Kierunek praktycznej nauki zawodu lub kształcenia"
      >
        <Form.Control
          as="textarea"
          rows={3}
          value={textOrEmpty(externalReferral?.examWithTests?.fieldOfStudy)}
          onChange={e => propertyChangeExam({ fieldOfStudy: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="endDateScience" label="Data końca nauki">
        <Form.Control
          type="date"
          name="endScience"
          placeholder="DateRange"
          value={momencik(
            externalReferral?.examWithTests?.endScience,
            'YYYY-MM-DD',
          )}
          onChange={e =>
            propertyChangeExam({
              endScience: new Date(e.target.value),
            })
          }
        />
      </FormRow>
    </>
  );
};

export default StudentForm;
